export const FISCAL_YEAR_START_MONTH = 4;
export const FISCAL_YEAR_END_MONTH = 3;

/**
 * 会計年度（FY）を開始年の西暦で返す。
 * 例:
 * - 2025-05-01 -> 2025 (FY25)
 * - 2025-03-31 -> 2024 (FY24)
 * - 2026-03-20 -> 2025 (FY25)
 */
export const getFiscalYear = (input: Date | string | number = new Date()): number => {
  const date = input instanceof Date ? input : new Date(input);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  return month >= FISCAL_YEAR_START_MONTH ? year : year - 1;
};

export const toFiscalYearLabel = (fiscalYear: number, prefix: string = 'FY'): string => {
  return `${prefix}${String(fiscalYear).slice(-2)}`;
};

type FiscalYearInput = number | string;

export type FiscalYearRangeYmd = {
  fiscalYear: number;
  from: string;
  to: string;
};

/**
 * FY表記（例: FY25）または開始年（例: 2025）から年度期間を逆引きする。
 * 返却形式:
 * - from: YYYY/M/D
 * - to  : YYYY/M/D
 */
export const getFiscalYearRange = (input: FiscalYearInput): FiscalYearRangeYmd => {
  const raw = String(input ?? '').trim().toUpperCase();
  if (!raw) {
    throw new Error('Fiscal year input is required.');
  }

  const fyMatch = raw.match(/^FY(\d{2}|\d{4})$/);
  let fiscalYear: number;

  if (fyMatch) {
    const n = Number(fyMatch[1]);
    fiscalYear = fyMatch[1].length === 2 ? 2000 + n : n;
  } else if (/^\d{4}$/.test(raw)) {
    fiscalYear = Number(raw);
  } else {
    throw new Error(`Invalid fiscal year input: ${input}`);
  }

  const startYear = fiscalYear;
  const endYear = fiscalYear + 1;
  return {
    fiscalYear,
    from: `${startYear}/${FISCAL_YEAR_START_MONTH}/1`,
    to: `${endYear}/${FISCAL_YEAR_END_MONTH}/31`,
  };
};
